/**
 * runidea.ai — Phase 13 — Deal-type pill.
 *
 * Small colored chip used in DealDetail headers + Dashboard recent-deals
 * rows. Color mapping is consistent across the app:
 *   Rental      → emerald
 *   Flip        → orange
 *   BRRRR       → purple
 *   Multifamily → blue
 */
import { Building2, Hammer, Home, Wrench } from "lucide-react";

export const DEAL_TYPE_META = {
  rental: {
    label: "Rental",
    Icon: Home,
    cls: "bg-emerald-50 text-emerald-700 border-emerald-200",
    accent: "emerald",
  },
  flip: {
    label: "Flip",
    Icon: Hammer,
    cls: "bg-orange-50 text-orange-700 border-orange-200",
    accent: "orange",
  },
  brrrr: {
    label: "BRRRR",
    Icon: Wrench,
    cls: "bg-purple-50 text-purple-700 border-purple-200",
    accent: "purple",
  },
  multifamily: {
    label: "Multifamily",
    Icon: Building2,
    cls: "bg-blue-50 text-blue-700 border-blue-200",
    accent: "blue",
  },
};

export default function DealTypePill({ type, size = "md", testid }) {
  const t = String(type || "rental").toLowerCase();
  const meta = DEAL_TYPE_META[t] || DEAL_TYPE_META.rental;
  const Icon = meta.Icon;
  const sz =
    size === "sm"
      ? "px-1.5 py-0.5 text-[10px] gap-1"
      : size === "lg"
      ? "px-3 py-1 text-sm gap-1.5"
      : "px-2 py-0.5 text-xs gap-1";
  const iconSize = size === "lg" ? "h-3.5 w-3.5" : "h-3 w-3";
  return (
    <span
      data-testid={testid || `deal-type-pill-${t}`}
      className={`inline-flex items-center rounded-full border font-semibold uppercase tracking-wider ${meta.cls} ${sz}`}
    >
      <Icon className={iconSize} />
      {meta.label}
    </span>
  );
}
